import { useSelector } from 'react-redux';
import { EditFormModal } from './EditFormModal';

export const Modals = () => {
  const modals = useSelector(state => state.modals);

  let modal;
  if (modals.showEditFormModal) {
    modal = <EditFormModal />;
  }

  return <>{modal}</>;
};
